import * as React from "react";
import {ProductsEnum, resourcesHelper} from "@falcon/services";

interface IProps {
    product: ProductsEnum,
}

export class NCDImpactedClaimBanner extends React.Component<IProps> {

    public render(): React.ReactNode {
        return (
            <div className="banner">
                <img src={`/${resourcesHelper.THEME}/img/Flow-info.svg`} alt="Blue info icon"/>
                <div className="banner-text">
                    <p><span className="font-weight-bold">Heads up</span> - Your {resourcesHelper.PRODUCT} {this.props.product === ProductsEnum.HOME ? "Home" : "Car"} Insurance policy has been cancelled,
                        but due to a claim you’ve made we will continue to collect the remaining monthly payments in line with our T&C’s.</p>
                </div>
            </div>
        )
    }
}
